<template>
  <div class="empty-wrapper">
    <div class="empty-container">
      <img class="empty-img" src="../../../empty/assets/empty.png" alt="" />
      <div class="empty-text">
        <p>{{ gettext('暂无数据') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.empty-wrapper {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 16px;
  align-items: center;
  // padding: 80px 165px;
  padding-top: 32px;
  margin: 32px -40px -32px;
  background: #f2f2f5;
  .empty-container {
    background: #fff;
    border-radius: 24px;
    padding: 80px 165px;
  }
  .empty-img {
    width: 358px;
    height: 280px;
  }

  .empty-text {
    font-family: PingFangSC-Regular;
    font-size: 28px;
    color: #595c66;
    text-align: center;
    line-height: 36px;
    font-weight: 400;
  }
}
</style>
